module.exports = __webpack_public_path__ + "assets/retina_CMidpointDetailed.c30e7fdf80c59a9ce4b3f076c3fd4ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CMidpointDetailed.png
// module id = 629
// module chunks = 0